/**
 * Swym Wishlist z-index fix — AGGRESSIVE approach
 *
 * The Swym app injects a floating heart button via a custom element
 * (swym-storefront-layout) with Shadow DOM. The app continuously sets
 * high inline z-index on its container, overriding CSS.
 *
 * This script:
 * 1. Continuously forces z-index LOW on all Swym containers (every 200ms)
 * 2. When any overlay is open (menu/search/cart), hides Swym completely
 * 3. Watches for body class changes AND directly checks overlay element states
 */
(function () {
    'use strict';

    var SWYM_SELECTORS = [
        'swym-storefront-layout',
        '#swym-storefront-extention-render-container',
        '.swym-storefront-layout-root-component',
        '#swym-plugin',
        '#swym-hosted-plugin',
        '.swym-wishlist-button-bar',
        '.swym-button-bar',
        '.swym-button'
    ].join(',');

    var OVERLAY_CLASSES = [
        'overflow-hidden',
        'overflow-hidden-mobile',
        'overflow-hidden-tablet',
        'overflow-hidden-desktop',
        'gl-overlay-open'
    ];

    function getSwymEls() {
        return document.querySelectorAll(SWYM_SELECTORS);
    }

    function isOverlayOpen() {
        // Check body and html classes
        for (var i = 0; i < OVERLAY_CLASSES.length; i++) {
            if (document.body.classList.contains(OVERLAY_CLASSES[i])) return true;
            if (document.documentElement.classList.contains(OVERLAY_CLASSES[i])) return true;
        }
        // Direct element checks
        var md = document.getElementById('Details-menu-drawer-container');
        if (md && md.hasAttribute('open')) return true;
        var sd = document.querySelector('details-modal.header__search > details[open]');
        if (sd) return true;
        var cd = document.querySelector('cart-drawer');
        if (cd && (cd.hasAttribute('open') || cd.classList.contains('active'))) return true;
        // Check cart drawer inner element
        var cdInner = document.querySelector('cart-drawer .drawer');
        if (cdInner && cdInner.getAttribute('aria-hidden') === 'false') return true;
        return false;
    }

    function enforceZIndex() {
        var els = getSwymEls();
        var overlayOpen = isOverlayOpen();

        for (var i = 0; i < els.length; i++) {
            if (overlayOpen) {
                // HIDE completely when overlay is open
                els[i].style.setProperty('display', 'none', 'important');
                els[i].style.setProperty('visibility', 'hidden', 'important');
                els[i].style.setProperty('pointer-events', 'none', 'important');
                els[i].style.setProperty('opacity', '0', 'important');
                els[i].style.setProperty('z-index', '-1', 'important');
            } else {
                // Show but keep z-index LOW
                els[i].style.removeProperty('display');
                els[i].style.removeProperty('visibility');
                els[i].style.removeProperty('pointer-events');
                els[i].style.removeProperty('opacity');
                els[i].style.setProperty('z-index', '990', 'important');
            }

            // NEW: Pierce Shadow DOM to hide/show inner content
            if (els[i].shadowRoot) {
                var shadowStyle = els[i].shadowRoot.querySelector('#gl-swym-shadow-hide');
                if (!shadowStyle) {
                    shadowStyle = document.createElement('style');
                    shadowStyle.id = 'gl-swym-shadow-hide';
                    els[i].shadowRoot.appendChild(shadowStyle);
                }
                if (overlayOpen) {
                    shadowStyle.textContent = ':host { display:none!important; visibility:hidden!important; } * { display:none!important; visibility:hidden!important; }';
                } else {
                    shadowStyle.textContent = '';
                }
            }
        }
    }

    function init() {
        // Run immediately
        enforceZIndex();

        // AGGRESSIVE: run every 200ms to counteract Swym's own JS
        setInterval(enforceZIndex, 200);

        // Also watch body/html class changes for immediate response
        if (window.MutationObserver) {
            var observer = new MutationObserver(enforceZIndex);
            observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
            observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

            // Watch menu drawer
            var md = document.getElementById('Details-menu-drawer-container');
            if (md) {
                new MutationObserver(function () {
                    setTimeout(enforceZIndex, 10);
                    setTimeout(enforceZIndex, 100);
                }).observe(md, { attributes: true, attributeFilter: ['open'] });
            }

            // Watch cart drawer
            var cd = document.querySelector('cart-drawer');
            if (cd) {
                new MutationObserver(function () {
                    setTimeout(enforceZIndex, 10);
                    setTimeout(enforceZIndex, 100);
                }).observe(cd, { attributes: true, attributeFilter: ['open', 'class'] });
            }
        }

        // Click fallback
        document.addEventListener('click', function () {
            setTimeout(enforceZIndex, 50);
            setTimeout(enforceZIndex, 200);
            setTimeout(enforceZIndex, 500);
        }, true);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(init, 500);
        });
    } else {
        setTimeout(init, 500);
    }

    // Extra backup for late-loading Swym app
    setTimeout(function () { if (document.body) init(); }, 2000);
    setTimeout(function () { if (document.body) init(); }, 5000);

    /* ── FIX: Stop wishlist button clicks from opening the image lightbox ──
       The Swym button is injected INSIDE <modal-opener> (Shopify's
       image lightbox trigger). Clicks bubble up to <modal-opener>,
       opening the lightbox instead of adding to wishlist.
       We ONLY intercept Swym buttons that are inside modal-opener. */
    function patchSwymClicks() {
        // Only target Swym buttons that are INSIDE a modal-opener
        var btns = document.querySelectorAll(
            'modal-opener #swym-atw-pdp-button,' +
            'modal-opener .atw-button,' +
            'modal-opener .swym-button,' +
            'modal-opener [id*="swym"]'
        );
        btns.forEach(function (btn) {
            if (btn._glSwymPatched) return;
            btn._glSwymPatched = true;
            btn.addEventListener('click', function (e) {
                e.stopPropagation();
            }, false); // bubbling phase so Swym's own handler fires first
        });
    }

    // Run repeatedly since Swym injects buttons dynamically
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            setTimeout(patchSwymClicks, 1000);
            setTimeout(patchSwymClicks, 3000);
            setTimeout(patchSwymClicks, 6000);
        });
    } else {
        setTimeout(patchSwymClicks, 1000);
        setTimeout(patchSwymClicks, 3000);
        setTimeout(patchSwymClicks, 6000);
    }
    setInterval(patchSwymClicks, 2000);
})();
